export default __webpack_public_path__ + "static/media/pseudonymjones.d9e8b527.jpeg";